"use client"

import React, {useEffect, useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Footer from "@/app/(index)/footer";
import Bread, {BreadLv3} from "@/app/(index)/bread";
import {IResearcherDTO} from "@/form/researcher";
import {loadGroupPRRList, loadGroupPRRTabs, loadResearcherById, loadResearcherListByType} from "@/service";
import {Divider, Image, UnstyledButton} from "@mantine/core";
import {useMediaQuery} from "@mantine/hooks";

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const Page = ({params}: { params: { id: string } }) => {
    const {fontSize} = useGlobalStateStore();
    const [entity, setEntity] = useState<IResearcherDTO | null>(null);
    const [list, setList] = useState<IResearcherDTO[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        loadResearcherById(params.id).then(data => {
            setEntity(data);
            setLoading(false);
            loadResearcherListByType(data.type!!).then(list => {
                setList(list);
            });
        });
    }, []);
    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                {
                    mediaQueryLessSM && (
                        <BreadLv3 name_c="關於科政中心 - 合聘研究員" name_e="關於科政中心 - 合聘研究員" lv1Link="/consultant"
                                  name_c_lv2={entity?.name} name_e_lv2={entity?.name}/>
                    )
                }


                <div
                    className={cx("mx-auto mb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                    <div className="mt-[60px]">
                        <div className={cx("flex ", mediaQueryLessSM ? 'gap-[120px]' : 'flex-col gap-[20px]')}>
                            <div className={cx(mediaQueryLessSM ? 'w-[260px]' : 'w-[200px]')}>
                                <Image
                                    src={`${process.env.NEXT_PUBLIC_API_HOST}/image/crop/${entity?.photoArhId?.arhId}`}
                                    className="border border-[#ccc]"
                                    radius={150}/>
                            </div>

                            <div className="flex flex-col flex-1">
                                <div className="flex flex-col">
                                    <div
                                        className="text-[30px] text-black">{entity?.type == "A" ? "資深顧問" : "合聘研究員"}</div>
                                    <div className="text-[46px] text-[#8d7f4c] font-extrabold">{entity?.name}</div>
                                </div>
                                <Divider color={"#cedbdc"} mb={40} mt={40}/>
                                <div className="flex flex-col gap-[30px]">

                                    {
                                        (entity?.positionList.length!! > 0) && (
                                            <div>
                                                <div className="text-[30px] text-black font-bold">現職</div>
                                                <div className="text-[20px] leading-[40px]">
                                                    {
                                                        entity?.positionList.map((item, index) => (
                                                            <div key={`position-${index}`}>{item}</div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        (entity?.experienceList.length!! > 0) && (
                                            <div>
                                                <div className="text-[30px] text-black font-bold">經歷</div>
                                                <div className="text-[20px] leading-[40px]">
                                                    {
                                                        entity?.experienceList.map((item, index) => (
                                                            <div key={`position-${index}`}>{item}</div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        (entity?.expertise?.trim().length!! > 0) && (
                                            <div>
                                                <div className="text-[30px] text-black font-bold">專長</div>
                                                <div className="text-[20px] leading-[40px]">
                                                    {entity?.expertise?.trim()}
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        (entity?.educationList.length!! > 0) && (
                                            <div>
                                                <div className="text-[30px] text-black font-bold">學歷</div>
                                                <div className="text-[20px] leading-[40px]">
                                                    {
                                                        entity?.educationList.map((item, index) => (
                                                            <div key={`position-${index}`}>{item}</div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }


                                    {
                                        (entity?.honorList.length!! > 0) && (
                                            <div>
                                                <div className="text-[30px] text-black font-bold">榮譽</div>
                                                <div className="text-[20px] leading-[40px]">
                                                    {
                                                        entity?.honorList.map((item, index) => (
                                                            <div key={`honer-${index}`}>{item}</div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="bg-[#f2f5f6] pt-[45px]">
                    <div className={cx("mx-auto pb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full px-[10px]')}>
                        <div className="font-bold text-[27px]">
                            其他{entity?.type == "A" ? "合聘研究員" : "資深顧問"}
                        </div>
                        <div className="mt-[35px] flex flex-wrap gap-[30px]">
                            {
                                list.filter(item => item.resId !== params.id).map((item) => (
                                    <UnstyledButton key={`r-${item.resId}`}
                                                    component="a" target="_self"
                                                    href={`/consultant/${item.resId}`}
                                                    className="w-[160px] flex flex-col items-center gap-[15px]">

                                        <Image
                                            src={`${process.env.NEXT_PUBLIC_API_HOST}/image/crop/${item.photoArhId?.arhId}`}
                                            className="border border-[#ccc]"
                                            radius={150}/>

                                        <div className="text-[22px] ">{item.name}</div>
                                    </UnstyledButton>
                                ))
                            }
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    );
}

export default Page;
